module.exports = __webpack_public_path__ + "media/home3.0e868207.mp4";